import windowSize from '@/mixins/window-size.js'
export default {
  mixins: [windowSize],
  data () {
    return {
      Placement: 'Bottom',
      DefaultTab: '',
      ActiveTab: '',
      IsNavigationVisible: false,
      tempTab: ''
    }
  },
  watch: {
    'DefaultTab': {
      handler: 'onDefaultTabChanged'
    },
    'ActiveTab': {
      handler: 'onActiveTabChanged'
    }
  },
  methods: {
    onDefaultTabChanged (value, oldValue) {
      if (value != oldValue) {
        this.setDefaultTab()
      }
    },
    onActiveTabChanged (value, oldValue) {
      if (value != oldValue) {
        this.tempTab = value || this.tempTab
        this.applyTabChange()
      }
    },
    setDefaultTab () {
      this.tempTab = this.DefaultTab
      this.applyTabChange()
    },
    applyTabChange () {
      if (this.checkIfTabIsNeeded()) {
        this.ActiveTab = this.tempTab
        this.IsNavigationVisible = true
      } else {
        this.ActiveTab = ''
        this.IsNavigationVisible = false
      }
    },
    checkIfTabIsNeeded () {
      return !!this.isMaxWidth480()
    },
    onWindowResize () {
      window.addEventListener('resize', this.applyTabChange)
    }
  },
  mounted () {
    this.onWindowResize()
  }
}
